var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyBorderedBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36305B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy-bordered-black_svg__clip0_7075_37431)",
    stroke: "#fff",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.334 9.225H10.52c-.714 0-1.292.578-1.292 1.292v5.816c0 .713.578 1.292 1.292 1.292h5.815c.714 0 1.293-.579 1.293-1.293v-5.815c0-.714-.579-1.292-1.293-1.292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.504 15.146a1.292 1.292 0 01-.379-.913v-4.86a2.248 2.248 0 012.249-2.248h4.859c.342 0 .671.136.913.379"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-bordered-black_svg__clip0_7075_37431"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.25 5.25)",
    d: "M0 0h13.5v13.5H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiIGZpbGw9IiMzNjMwNUIiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzcwNzVfMzc0MzEpIj4KPHBhdGggZD0iTTE2LjMzNDMgOS4yMjQ4NUgxMC41MTg5QzkuODA1MTUgOS4yMjQ4NSA5LjIyNjU2IDkuODAzNDQgOS4yMjY1NiAxMC41MTcyVjE2LjMzMjVDOS4yMjY1NiAxNy4wNDYzIDkuODA1MTUgMTcuNjI0OSAxMC41MTg5IDE3LjYyNDlIMTYuMzM0M0MxNy4wNDggMTcuNjI0OSAxNy42MjY2IDE3LjA0NjMgMTcuNjI2NiAxNi4zMzI1VjEwLjUxNzJDMTcuNjI2NiA5LjgwMzQ0IDE3LjA0OCA5LjIyNDg1IDE2LjMzNDMgOS4yMjQ4NVoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS4xMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy41MDM1MSAxNS4xNDY1QzcuMjYxMTUgMTQuOTA0MSA3LjEyNSAxNC41NzU0IDcuMTI1IDE0LjIzMjdDNy4xMjUgMTMuMzIxNyA3LjEyNSAxMS4wOTQ0IDcuMTI1IDkuMzczODlDNy4xMjUgOC4xMzEyNSA4LjEzMTI1IDcuMTI1IDkuMzczODkgNy4xMjVDMTEuMDk0NCA3LjEyNSAxMy4zMjE3IDcuMTI1IDE0LjIzMjcgNy4xMjVDMTQuNTc1NCA3LjEyNSAxNC45MDQxIDcuMjYxMTUgMTUuMTQ2NSA3LjUwMzUxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuMTI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF83MDc1XzM3NDMxIj4KPHJlY3Qgd2lkdGg9IjEzLjUiIGhlaWdodD0iMTMuNSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuMjUgNS4yNSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgCopyBorderedBlack as ReactComponent };